export default "__VITE_ASSET__BZ1fiM2X__"